import { render, staticRenderFns } from "./PodcastScriptPanel.vue?vue&type=template&id=15a06b47&scoped=true"
import script from "./PodcastScriptPanel.vue?vue&type=script&lang=js"
export * from "./PodcastScriptPanel.vue?vue&type=script&lang=js"
import style0 from "./PodcastScriptPanel.vue?vue&type=style&index=0&id=15a06b47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a06b47",
  null
  
)

export default component.exports